import { ConverterType } from '../domain';
import { createMediaConverter } from './base-media';
const WIX_AUDIO = 'audio';
const WIX_AUDIO_COMMON_TYPE = 'wix.common.Audio';
const baseMediaConverter = createMediaConverter(WIX_AUDIO, WIX_AUDIO_COMMON_TYPE);
export const audio = {
    types: [WIX_AUDIO_COMMON_TYPE],
    [ConverterType.FROM_JSON]: {
        transform: (val) => {
            const duration = val?.duration ?? 0;
            const url = baseMediaConverter[ConverterType.FROM_JSON].transform(val);
            return `${url}${val?.id ? `#duration=${duration}` : ''}`;
        },
    },
    [ConverterType.TO_JSON]: {
        transform: (val) => {
            return baseMediaConverter[ConverterType.TO_JSON].transform(val);
        },
    },
};
//# sourceMappingURL=audio.js.map